import React, { useState, useEffect } from "react";
import { Input } from "../Layout/Forms/Form";
import { useNavigate, Link } from "react-router-dom";
import "./ForgotPassword.css";
import ForgotPasswordRequests from "./ForgotPasswordRequests";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../components/Loading";

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Recover password | Nightspot";
  }, []);

  const [state, setState] = useState({
    form: {
      email: "",
    },
    errors: [],
  });

  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const handleForgotRequest = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let params = state.form;
    let response = await ForgotPasswordRequests.sendEmailForgotPassword(params);
    if (response && response.status === true) {
      toast.success(
        "Enviámos-lhe um e-mail com instruções para redefinir a sua palavra-passe.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          onClose: () => navigate(`/login`),
        },
      );
      setState({
        ...state,
        form: {
          ...state.form,
          email: "",
        },
      });
    }
    setIsLoading(false);
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="recover-password-container d-flex justify-content-center align-items-center min-vh-100">
      {/* <ToastContainer /> */}
      <div className="recover-password-wrapper">
        <div className="text-center mb-4">
          <h4>Perdeu a sua Password?</h4>
          <span className="title-description">
            Não se preocupe, enviamos-lhe um e-mail com instruções
          </span>
        </div>

        <form onSubmit={handleForgotRequest}>
          <div className="form-group">
            <Input
              label="E-mail"
              name="email"
              value={state.form.email}
              onChange={(e) => handleChangeInputs(e)}
              errors={state.errors}
              placeholder="Escreva o seu email"
            />
          </div>

          <div className="form-group mt-4 d-grid">
            <button type="submit" className="btn btn-primary btn-block">
              Recuperar password
            </button>
          </div>
        </form>

        <div className="text-center mt-5">
          <Link to="/login" className="link-nostyle">
            <i className="fa-solid fa-arrow-left"></i> VOLTAR AO LOGIN
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
